import { NgModule } from '@angular/core';
import { MainNavigationFeatureModule } from '@main/navigation/feature';

@NgModule({
  imports: [MainNavigationFeatureModule],
})
export class MainNavigationShellModule {}
